import storePublisherPlugin from "@/store/plugins/index";
import bus from "@/bus";

jest.mock("@/bus", () => ({
  $emit: jest.fn()
}));

describe("storePublisherPlugin de plugins index.js", () => {
  it("debería ser una función y emitir un evento", () => {
    const mockStore = {
      subscribe: jest.fn()
    };

    const mockMutation = { type: "testMutation" };
    const mockState = { test: "state" };

    storePublisherPlugin(mockStore);
    const subscribeCallback = mockStore.subscribe.mock.calls[0][0];
    subscribeCallback(mockMutation, mockState);

    expect(storePublisherPlugin).toBeInstanceOf(Function);
    expect(storePublisherPlugin(mockStore)).not.toBeNull();
    expect(mockStore.subscribe).toHaveBeenCalled();
    expect(bus.$emit).toHaveBeenCalledWith("mutation", {
      mutation: mockMutation,
      state: mockState
    });
  });
});
